var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgEye = function SvgEye(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 4.00024C6.80485 4.00024 2.36833 7.31678 0.571777 12.0002C2.36833 16.6835 6.80485 20.0001 12.0002 20.0001C17.1944 20.0001 21.631 16.6835 23.4287 12.0002C21.631 7.31678 17.1944 4.00024 12.0002 4.00024ZM12.0002 6.28593C15.8322 6.28593 19.2539 8.50076 20.9407 12.0002C19.2539 15.4995 15.8322 17.7144 12.0002 17.7144C8.16715 17.7144 4.74547 15.4995 3.05978 12.0002C4.74547 8.50076 8.16715 6.28593 12.0002 6.28593Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0016 7.41089C9.47587 7.41089 7.43018 9.45772 7.43018 11.9823C7.43018 14.508 9.47587 16.5536 12.0016 16.5536C14.5261 16.5536 16.5729 14.508 16.5729 11.9823C16.5729 9.45772 14.5261 7.41089 12.0016 7.41089ZM12.0016 9.69658C13.2622 9.69658 14.2873 10.7217 14.2873 11.9823C14.2873 13.244 13.2622 14.268 12.0016 14.268C10.741 14.268 9.71592 13.244 9.71592 11.9823C9.71592 10.7217 10.741 9.69658 12.0016 9.69658Z",
    fill: "currentColor"
  })));
};
export default SvgEye;